import { render, staticRenderFns } from "./fccImportacaoDadosCadastrais.vue?vue&type=template&id=3f05b5fa"
import script from "./fccImportacaoDadosCadastrais.vue?vue&type=script&lang=js"
export * from "./fccImportacaoDadosCadastrais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports